import { reqF } from "./axiosFun";
export async function scheduledTaskRequest(action, params = {}) {
	const res = await reqF("post", "/api/sysConfig/ScheduledTask/" + action, params);
	if (res.code !== 1) throw new Error(res.msg || "操作失败");
	return res.data;
}
